import React, {useEffect, useState} from 'react'
import { Link } from 'react-router-dom'
import { useSearchParams } from 'react-router-dom';
import small4 from "../../../../assets/images/small/img-4.jpg"
import small6 from "../../../../assets/images/small/img-6.jpg"
import small7 from "../../../../assets/images/small/img-7.jpg"
import { Card, CardBody, Col } from 'reactstrap'
import ApiService from "../../util/ApiService";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
const Sidepanel = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [search, setSearch] = useState(searchParams.get('search') || '');
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch();
    }, []);
    const fetch = async () => {
        try {
            setLoading(true);
            const response = await ApiService.send('get', process.env.REACT_APP_URL_API + 'guide-user/list-categories',
                {}, true
            );

            const {data} = ApiService.handleApiResponse(response);
            setCategories(data);

        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = () => {
        const query = encodeURIComponent(search.trim());
        window.location.href = `/admin/user-guide?description=${query}`;
    };


    return (
        <React.Fragment>
            <Col xxl={3}>
                <Card>
                    <CardBody className="p-4">
                        <div className="position-relative mb-3">
                            <input
                                type="text"
                                className="form-control rounded bg-light border-light pe-5"
                                placeholder="Sua pesquisa..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                            />
                            <button type="button"
                                className="btn position-absolute top-50 end-0 translate-middle-y me-2 text-secondary"
                                style={{zIndex: 2}}
                                onClick={() =>handleSearch()}
                            >
                                <i className="fa fa-search"></i>
                            </button>
                        </div>

                        <div className="mt-4 pt-4 border-top border-dashed border-bottom-0 border-start-0 border-end-0">
                            <p className="text-muted">Categorias</p>

                            <ul className="list-unstyled fw-medium">
                                <li><Link to="/admin/user-guide" className="text-muted py-2 d-block"><i
                                    className="mdi mdi-chevron-right me-1"></i>Todos</Link></li>
                                {loading ? (
                                    Array.from({length: 5}).map((_, i) => (
                                        <li key={i}>
                                            <Skeleton height={20} style={{marginBottom: '10px'}}/>
                                        </li>
                                    ))
                                ) : (
                                    categories.map((cat, index) => (
                                        <li><a
                                            href={`/admin/user-guide?category=${cat.id}`}
                                            className="text-muted py-2 d-block"><i
                                            className="mdi mdi-chevron-right me-1"></i>{cat.name}</a></li>
                                    ))
                                )}
                            </ul>
                        </div>

                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    )
}

export default Sidepanel